import { Link } from 'react-router-dom';
import { newsList } from '@/mocks/news';
import { versionList } from '@/mocks/updates';

const hotList = [...newsList].sort((a, b) => b.views - a.views).slice(0, 6);
const latestVersion = versionList[0];

const hotTags = ['6.2版本', '胡桃', '深境螺旋', '配队', '圣遗物', '海灯节', '纳西妲', '融化流'];

export default function HomeSidebar() {
  return (
    <aside className="flex flex-col gap-5">
      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <div className="mb-4 flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-100 text-secondary-600">
            <i className="ri-fire-line"></i>
          </span>
          <h3 className="font-heading text-base font-bold text-foreground-950">热门排行</h3>
        </div>
        <ol className="flex flex-col gap-3">
          {hotList.map((article, index) => (
            <li key={article.id}>
              <Link to={`/detail/${article.id}`} className="group flex items-start gap-3">
                <span
                  className={`flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                    index < 3
                      ? 'bg-accent-500 text-white'
                      : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {index + 1}
                </span>
                <span className="min-w-0">
                  <span className="block text-sm text-foreground-800 line-clamp-2 transition-colors group-hover:text-primary-700">
                    {article.title}
                  </span>
                  <span className="mt-1 inline-flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-eye-line"></i>
                    {article.views.toLocaleString()}
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>

      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
        <div className="relative h-36 w-full overflow-hidden">
          <img
            src={latestVersion.cover}
            alt={`原神 ${latestVersion.version} 版本`}
            className="absolute inset-0 h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/75 to-transparent"></div>
          <div className="absolute bottom-3 left-4">
            <span className="rounded-full bg-accent-500 px-2.5 py-0.5 text-xs font-semibold text-white">
              v{latestVersion.version}
            </span>
            <p className="mt-2 font-heading text-lg font-bold text-white">{latestVersion.name}</p>
          </div>
        </div>
        <div className="p-5">
          <p className="text-xs text-foreground-500">上线时间 {latestVersion.date}</p>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-3">
            {latestVersion.summary}
          </p>
          <ul className="mt-3 flex flex-col gap-1.5">
            {latestVersion.highlights.slice(0, 3).map((item) => (
              <li key={item} className="flex items-start gap-2 text-xs text-foreground-600">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
                {item}
              </li>
            ))}
          </ul>
          <Link
            to="/updates"
            className="mt-4 inline-flex w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 py-2.5 text-sm font-medium text-primary-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
          >
            查看版本详情
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <div className="mb-4 flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-primary-600">
            <i className="ri-price-tag-3-line"></i>
          </span>
          <h3 className="font-heading text-base font-bold text-foreground-950">热门标签</h3>
        </div>
        <div className="flex flex-wrap gap-2">
          {hotTags.map((tag) => (
            <Link
              key={tag}
              to="/news"
              className="rounded-full bg-secondary-50 px-3 py-1.5 text-xs font-medium text-secondary-700 transition-colors hover:bg-secondary-100"
            >
              {tag}
            </Link>
          ))}
        </div>
      </div>
    </aside>
  );
}